import { render, staticRenderFns } from "./validation_email_page.vue?vue&type=template&id=59cab5d4&scoped=true"
import script from "./validation_email_page.vue?vue&type=script&lang=js"
export * from "./validation_email_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cab5d4",
  null
  
)

export default component.exports